import api from './api';
import { AuthResponse, User, Tenant } from '@/types';

export interface ChangePasswordData {
  current_password: string;
  new_password: string;
}

export interface ResetPasswordData {
  user_id: number;
  new_password?: string;
}

export interface ResetPasswordResponse {
  message: string;
  temporary_password?: string;
}

export const authService = {
  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  async register(
    tenant: { name: string; slug: string },
    admin: { email: string; password: string; full_name: string }
  ): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/register', admin, {
      params: tenant,
    });
    return response.data;
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },

  async getTenant(token?: string): Promise<Tenant> {
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    const response = await api.get<Tenant>('/auth/tenant', { headers });
    return response.data;
  },

  async changePassword(data: ChangePasswordData): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/auth/change-password', data);
    return response.data;
  },

  async resetPassword(data: ResetPasswordData): Promise<ResetPasswordResponse> {
    const response = await api.post<ResetPasswordResponse>('/auth/reset-password', data);
    return response.data;
  },

  async forgotPassword(email: string): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/auth/forgot-password', { email });
    return response.data;
  },

  async logout(refreshToken?: string | null): Promise<void> {
    // Revoca el access token (header) y el refresh token (body) del lado del servidor
    await api.post('/auth/logout', { refresh_token: refreshToken ?? undefined });
  },
};
